import React, { useEffect, useState } from "react";
import DisplayTable from "../../components/DisplayTable";
import { useSelector } from "react-redux";
import { selectCurrentEvent, selectRoom } from "../../features/store";
import { currEventCol, parseCurrentEventDisplay } from "../../models/CurrentEvent";

const CurrentEvent = ({ currBuilding }) => {
    const currentEvents = useSelector(selectCurrentEvent);
    const rooms = useSelector(selectRoom);
    const [displayEvents, setDisplayEvents] = useState([]);

    useEffect(() => {
        let filteredEvents = Object.keys(currentEvents)
            .filter((key) => {
                let rid = currentEvents[key].roomId;
                return rooms[rid]?.buildingId === currBuilding.buildingId;
            })
            .map((key) => {
                return parseCurrentEventDisplay(currentEvents[key]);
            });
        setDisplayEvents(filteredEvents);
    }, [currBuilding, currentEvents]);
    return (
        <div className="current-event">
            <DisplayTable headers={currEventCol} data={displayEvents} noData={!displayEvents.length} />
        </div>
    );
};

export default CurrentEvent;
